<template>
<div>
  
    <div  class="bg-customer border border-info rounded  ml-2  mr-2 mt-3 prevent-select"  v-if="customer.customerId > 0">
    <a  href="#" @click="close(),showData=false" class="card-link ml-3 mr-2  " data-toggle="tooltip" title="RESET CLIENTE"  >
      
      <!--<i style="color:#FF4500" class="fas fa-user-alt-slash" aria-hidden="true"></i>-->
      <i style="color : rgb(255,255,255);font-size: large;" class="fas fa-user-alt-slash " aria-hidden="true"></i>
      
    </a>
    <a @click="showData=!showData"  v-bind:style = "{color : customer.customerId > 0  ?  'white' : 'white' ,   fontSize : '25px' }"  role="button" aria-expanded="false" aria-controls="collapseExample">
      <span class="customer_data"> <span class="customer_label mr-2">CLIENTE</span> <strong> {{customer.last_name}} {{customer.first_name}} </strong>   </span>    
      <span v-show="showData" class="ml-3 customer_label" >TELEFONO <strong   class="ml-2 customer_data"> {{customer.mobile}} </strong>
        <button class="btn btn-default mr-1 mb-1" @click.stop="copyToClipBoard()"> 
          <i class="fas fa-clone"></i></button>
      </span>
      <span v-show="showData" class="ml-5 customer_label">SALDO € <strong class="ml-2 customer_data"    :style="{color: customer.balance < 0  ? 'red' :  'black'}">{{fmt1(customer.balance) }}</strong></span>
      <span v-show="showData" class="ml-5 customer_label">CASHBACK € <strong class="ml-2 customer_data" :style="{color: customer.cashback < 0  ? 'red' :  'black'}">{{fmt1(customer.cashback) }}</strong></span>
    </a>

   </div>
  </div>
</template>
<script>
   
import fmt from '@/components/mixins/fmt.js'    
export default {
  mixins:[fmt],
  props : ['customer'],
 
  components: {
    
  
  },
  data () 
  {
    return {

      showData : false
     
    }
  },
    computed: 
  {
    //...mapGetters(['storeId','company']) , 
  },
  mounted: function()
  {
    
  },
  methods :
  {
    
    copyToClipBoard() {

      if (navigator && navigator.clipboard && navigator.clipboard.writeText)
      return navigator.clipboard.writeText(this.customer.mobile)
    },

    close()
    {
     this.$emit('close')
    },
   
  }
}
</script>    
<style scoped>

span {
  font-size: 20px;
}
.bg-customer{ 
  background-color:  rgb(240, 204, 73);
}

.customer_label
{
  color:rgb(72, 55, 55);
}
.customer_data
{
  color     : black;
  font-size : 26px;
}
.prevent-select {
  -webkit-user-select : none; /* Safari */
  -ms-user-select     : none; /* IE 10 and IE 11 */
   user-select        : none; /* Standard syntax */
}

</style>



